import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import Link from 'components/links/Link';

export default function FileLink({url, label}) {
  const btnDisplayType = label === 'Supplement' ? 'btn-outline-primary' : 'btn-primary';
  return (
    <div>
      <Link className={clsx('btn', btnDisplayType)} href={url}>
        <FontAwesomeIcon icon="fa-regular fa-file-lines" />
        Download {label}
      </Link>
    </div>
  );
}
